<template>
        <div
        class="dropzone-container"
        :class="{'dropzone-container_active': isDragging}"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
        >
        <p class="file-label">
            Загрузить XLSX-файл
        </p>
    </div>
</template>

<script>
export default {
  name: 'DragAndDropFile',
  props: { onChangeFiles: {
    type: Function
  } },
  data () {
    return {
      isDragging: false,
      dragoverVariable: null,
      dropVariable: null
    }
  },
  created () {
    this.dragoverVariable = window.addEventListener('dragover', this.dragover)
    this.dropVariable = window.addEventListener('drop', this.drop)
  },
  beforeDestroy () {
    this.dragoverVariable && this.dragoverVariable.removeListener(this.dragover)
    this.dropVariable && this.dropVariable.removeListener(this.drop)
  },
  methods: {
    dragover (e) {
      e.preventDefault()
      this.isDragging = true
    },
    dragleave (e) {
      e.preventDefault()
      this.isDragging = false
    },
    drop (e) {
      e.preventDefault()
      if (e.dataTransfer.files.length) {
        this.onChangeFiles(e.dataTransfer.files)
      }
      this.isDragging = false
    }
  }
}
</script>

<style lang="scss">

.dropzone-container {
  display: none;
  &_active{
    background: rgba(0, 0, 0, 0.40);;
    border: 1px solid #e2e8f0;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.file-label {
  font-size: 60px;
  color: white;
}
</style>
